/* assets/vijvercheck-save.js
 * VijverCheck Phase 1 - "Bewaar deze meting" knop + cohort-modal-trigger.
 * Wordt geladen in sections/vijvercheck.liquid en luistert op vw:advice
 * (gefired in vijvercheck-v2.js renderAdviceCards). Bouwt CTA in #vw-save-cta.
 *
 * Endpoint (18-10-2026, fase 2 omschakelplan): POST /apps/vp/metingen, same-origin via de
 * Shopify App Proxy naar business.retailz.io (rz2-klant-ingang). Shopify tekent het verzoek
 * en zet logged_in_customer_id erbij; de klant komt nooit uit de body. Een gast bewaart
 * alleen op dit apparaat (DPIA A3, B-2026-10-18-3); na inloggen koppelt de historie-tab.
 *
 * Geen em/en-dash gebruikt (brandregel).
 *
 * Bug-fix 2026-05-27 (Agent FIX):
 * - [lock] en [save] placeholders vervangen door echte inline-SVG iconen
 *   (lucide style, 24x24, currentColor stroke).
 * - Login-return-flow: voor redirect naar /account/login wordt de advies-context
 *   opgeslagen in localStorage (vw_pending_save). Na inloggen + restore=1 in
 *   query string wordt context teruggehaald, advies opnieuw gefired en de
 *   save-knop pulseert (vw-pulse-cta) zodat klant weet wat te doen.
 * - Toast-systeem (rechtsonder mobile / rechtsboven desktop, 4s, slide-in).
 * - Save-knop heeft icon + tekst, loading/success/disabled states.
 */
(function(){
  'use strict';

  // 18-10-2026 (B-2026-10-18-3, DPIA A3): bewaren gaat same-origin naar /apps/vp/metingen
  // (Shopify App Proxy naar business.retailz.io; contract in app.retailz.io.v2
  // platform/customer-data/src/vijver-ingang.ts). Geen e-mailadres en geen handtekening uit
  // Liquid meer: Shopify tekent het verzoek en zet de ingelogde klant erbij. De oude route
  // (de Cloudflare-worker naar retailz-server en Supabase) en het auth-object uit
  // sections/vijvercheck.liquid zijn vervallen.
  var METINGEN_URL = '/apps/vp/metingen';
  // Funnel-instrumentatie (verbetercyclus run 3, 2026-07-14): meet CTA-shown/login/save/error
  var vwCtaShown = {};
  function vwTr(name, params){
    try {
      if (typeof window.vwTrack === 'function') { window.vwTrack(name, params || {}); }
      else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name, ts: Date.now() }, params || {})); }
    } catch(_){}
  }
  var PENDING_KEY = 'vw_pending_save';

  // -- Bewaren zonder account: op dit apparaat (run 7, 28-07-2026; DPIA A3, 18-10-2026) --
  // Een gast bewaart in deze browser (vw_metingen_v1), en dat zeggen we ook zo: een groene
  // bevestiging voor iets dat niet echt is opgeslagen is precies de fout die het Hookdeck-pad
  // in juli maakte. In het account bewaren kan alleen ingelogd (v2 bewaart geen e-mailhash).
  // Na het inloggen zet de historie-tab de lokale rijen er vanzelf in (vwKoppelLokaal).
  var LOKAAL_KEY = 'vw_metingen_v1';
  var LOKAAL_MAX = 24;
  var stap = 'bewaren';       // 'bewaren' -> 'bewaard'
  var lokaalBewaard = false;
  var metingId = null;        // idempotentie-sleutel van de meting die nu op het scherm staat

  // Elke meting krijgt een eigen UUID (veld `id` van POST /apps/vp/metingen). Een tweede
  // poging of een tweede koppelronde met hetzelfde id maakt in v2 geen tweede rij.
  var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  function nieuweMetingId(){
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch(_){}
    var b = [];
    for (var i = 0; i < 16; i++) b.push(Math.floor(Math.random() * 256));
    try { var r = new Uint8Array(16); window.crypto.getRandomValues(r); b = Array.prototype.slice.call(r); } catch(_){}
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    var h = b.map(function(x){ return (x < 16 ? '0' : '') + x.toString(16); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }

  function lokaleMetingen(){
    try {
      var l = JSON.parse(localStorage.getItem(LOKAAL_KEY) || '[]');
      return Array.isArray(l) ? l : [];
    } catch(_){ return []; }
  }
  function lokaalOpslaan(lijst){
    try { localStorage.setItem(LOKAAL_KEY, JSON.stringify(lijst)); return true; } catch(_){ return false; }
  }
  // Bewaart de meting van dit moment op het apparaat, met hetzelfde id als een poging naar
  // het account. Nog een keer aanroepen voor dezelfde meting geeft geen tweede rij. Boven de
  // 24 rijen gaat eerst de oudste rij weg die al in het account staat.
  // Uitkomst: het aantal lokale rijen, of 0 als de browser niets laat bewaren.
  function bewaarLokaal(cohort){
    try {
      var lijst = lokaleMetingen();
      var c = lastContext || {};
      var pond = (c.pond && typeof c.pond === 'object') ? c.pond : {};
      if (!metingId) metingId = nieuweMetingId();
      var bestaand = null;
      for (var i = 0; i < lijst.length; i++){ if (lijst[i] && lijst[i].id === metingId) bestaand = lijst[i]; }
      if (bestaand){
        bestaand.cohort_consent = !!cohort;
      } else {
        lijst.push({
          id: metingId,
          measured_at: new Date().toISOString(),
          postcode: (c.location && c.location.postcode) || null,
          measurements: c.measurements || {},
          pond: {
            depth_cm: pond.depth_cm != null ? pond.depth_cm : null,
            volume_l: pond.volume_l != null ? pond.volume_l : null,
            alg_type: (c.observations && c.observations.alg_type) || null
          },
          cohort_consent: !!cohort
        });
      }
      while (lijst.length > LOKAAL_MAX){
        var weg = 0;
        for (var j = 0; j < lijst.length; j++){ if (lijst[j] && lijst[j].gekoppeld){ weg = j; break; } }
        lijst.splice(weg, 1);
      }
      localStorage.setItem(LOKAAL_KEY, JSON.stringify(lijst));
      return lijst.length;
    } catch(_){ return 0; }
  }

  // -- Lokale metingen naar het account (16-10-2026, Kees: "de flow moet frictieloos zijn") --
  // 18-10-2026 (DPIA A3): zonder e-mailadres. vwKoppelLokaal stuurt elke lokale rij die nog
  // niet in het account staat naar POST /apps/vp/metingen, met de oorspronkelijke measured_at
  // en het eigen id van de rij. Dat werkt alleen ingelogd: de App Proxy zet de klant erbij.
  // Zonder sessie geeft de ingang 401 en blijven de rijen gewoon lokaal staan.
  //   opts.bestaand : rijen die al in het account staan; een lokale rij met dezelfde waarden
  //                   binnen 10 minuten wordt overgeslagen (die is al eerder opgestuurd).
  // Een overgezette rij wordt lokaal gemarkeerd (gekoppeld), niet gewist.
  // Uitkomst: { geupload, overgeslagen, fouten, resterend, ingelogd }.
  var MEAS_KEYS = ['pH','KH_dkh','GH_dkh','NO2_mg_l','NO3_mg_l','NH4_total_mg_l','O2_mg_l'];
  // Fosfaat (PO4) bewaart v2 pas sinds migratie 145 (B-2026-10-18-18). Een accountrij zonder PO4 kan
  // dus dezelfde meting zijn; alleen twee verschillende PO4-waarden maken er een andere meting van.
  var EXTRA_KEYS = ['PO4_mg_l'];
  var MAX_PER_RONDE = 30;   // de ingang staat 60 verzoeken per klant per 10 minuten toe
  function numOfNull(v){
    if (v === null || v === undefined || v === '') return null;
    var n = Number(v); return Number.isFinite(n) ? n : null;
  }
  function inBereik(v, min, max){
    var n = numOfNull(v);
    return (n !== null && n >= min && n <= max) ? n : null;
  }
  function zelfdeMeting(lokaal, account){
    var ta = Date.parse(lokaal && lokaal.measured_at), tb = Date.parse(account && account.measured_at);
    if (!Number.isFinite(ta) || !Number.isFinite(tb) || Math.abs(ta - tb) > 600000) return false;
    var m = (lokaal && lokaal.measurements) || {};
    for (var i = 0; i < MEAS_KEYS.length; i++){
      var k = MEAS_KEYS[i];
      if (numOfNull(m[k]) !== numOfNull(account[k])) return false;
    }
    for (var j = 0; j < EXTRA_KEYS.length; j++){
      var a = numOfNull(m[EXTRA_KEYS[j]]), b = numOfNull(account[EXTRA_KEYS[j]]);
      if (a !== null && b !== null && a !== b) return false;
    }
    return true;
  }
  // Zelfde vorm als buildPayload. De ingang bewaart diepte en volume alleen binnen zijn bereik
  // (30 tot 500 cm, 100 tot 1.000.000 liter); daarbuiten sturen we ze niet mee, zodat de
  // waterwaarden niet om de vijvergegevens worden geweigerd.
  function koppelPayload(r){
    var pond = (r && r.pond && typeof r.pond === 'object') ? r.pond : {};
    return {
      id: String(r.id).toLowerCase(),
      measured_at: r.measured_at,
      postcode: r.postcode || null,
      measurements: (r.measurements && typeof r.measurements === 'object') ? r.measurements : {},
      pond: {
        depth_cm: inBereik(pond.depth_cm, 30, 500),
        volume_l: inBereik(pond.volume_l, 100, 1000000),
        alg_type: pond.alg_type || null
      },
      source: 'vijvercheck-app',
      cohort_consent: r.cohort_consent === true
    };
  }
  // Een meting naar het account. Same-origin: de App Proxy zet de handtekening erbij.
  async function stuurMeting(payload){
    var resp = await fetch(METINGEN_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    var body = null;
    try { body = await resp.json(); } catch(_){}
    return { ok: resp.ok, status: resp.status, body: body };
  }
  async function koppelRonde(opts){
    opts = opts || {};
    var uit = { geupload: 0, overgeslagen: 0, fouten: 0, resterend: 0, ingelogd: true };
    var lijst = lokaleMetingen();
    var bestaand = Array.isArray(opts.bestaand) ? opts.bestaand : [];
    var verstuurd = 0;
    for (var i = 0; i < lijst.length; i++){
      var r = lijst[i];
      if (!r || !r.measured_at || r.gekoppeld) continue;
      if (bestaand.some(function(a){ return zelfdeMeting(r, a); })){
        uit.overgeslagen++;
        r.gekoppeld = { at: new Date().toISOString(), dubbel: true };
        continue;
      }
      if (!uit.ingelogd || verstuurd >= MAX_PER_RONDE) continue;
      // Eerst het id vastleggen: een afgebroken ronde gebruikt de volgende keer hetzelfde id.
      if (!r.id || !UUID_RE.test(String(r.id).toLowerCase())){ r.id = nieuweMetingId(); lokaalOpslaan(lijst); }
      verstuurd++;
      try {
        var res = await stuurMeting(koppelPayload(r));
        if (res.status === 422 && res.body && res.body.veld === 'measured_at'){
          // De klok van dit apparaat liep voor: bewaar dan met de tijd van de server.
          var zonderTijd = koppelPayload(r);
          delete zonderTijd.measured_at;
          res = await stuurMeting(zonderTijd);
        }
        // Zelfde body-guard als de bewaarknop: een 2xx alleen is geen bewijs.
        if (res.ok && res.body && res.body.ok === true && res.body.id){
          uit.geupload++;
          r.gekoppeld = { at: new Date().toISOString(), id: res.body.id };
        } else if (res.status === 401){
          uit.ingelogd = false;
          uit.fouten++;
        } else if (res.status === 422){
          // Voorgoed geweigerd (bijvoorbeeld geen enkele waterwaarde): niet blijven proberen.
          uit.fouten++;
          r.gekoppeld = { at: new Date().toISOString(), geweigerd: String((res.body && res.body.fout) || 'ongeldig').slice(0, 40) };
        } else {
          uit.fouten++;
        }
      } catch(e){ uit.fouten++; }
    }
    lokaalOpslaan(lijst);
    uit.resterend = lijst.filter(function(x){ return x && x.measured_at && !x.gekoppeld; }).length;
    vwTr('vw_lokaal_gekoppeld', { geupload: uit.geupload, overgeslagen: uit.overgeslagen, fouten: uit.fouten, ingelogd: uit.ingelogd });
    return uit;
  }
  // Een ronde tegelijk: een tweede aanroep (verversen, net bewaard) wacht op de lopende.
  var koppelBezig = null;
  function vwKoppelLokaal(opts){
    if (koppelBezig) return koppelBezig;
    koppelBezig = koppelRonde(opts).then(
      function(uit){ koppelBezig = null; return uit; },
      function(e){ koppelBezig = null; throw e; }
    );
    return koppelBezig;
  }
  // Na een geslaagde bewaaractie in het account: een lokale kopie van dezelfde meting (van een
  // eerdere mislukte poging) staat daarmee in het account.
  function markeerLokaalGekoppeld(id, accountId){
    if (!id) return;
    var lijst = lokaleMetingen(), raak = false;
    for (var i = 0; i < lijst.length; i++){
      if (lijst[i] && lijst[i].id === id && !lijst[i].gekoppeld){
        lijst[i].gekoppeld = { at: new Date().toISOString(), id: accountId || null };
        raak = true;
      }
    }
    if (raak) lokaalOpslaan(lijst);
  }
  window.vwKoppelLokaal = vwKoppelLokaal;
  window.vwLokaleMetingen = lokaleMetingen;

  // Login-return-detect: switch naar historie tab als we van /account/login terugkwamen
  try {
    var raw = localStorage.getItem('vw_post_login_action');
    if (raw) {
      var d = JSON.parse(raw);
      if (d && d.ts && (Date.now() - d.ts) < 600000 && d.tab) {
        setTimeout(function(){
          var t = document.querySelector('[data-vc-tab-btn="' + d.tab + '"]');
          if (t) t.click();
        }, 200);
      }
      localStorage.removeItem('vw_post_login_action');
    }
  } catch(_){}

  var HOST = document.getElementById('vw-save-cta');
  if (!HOST) return;

  // Tab-switch delegated (voor 'Bekijk historie' button in save-CTA)
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest && e.target.closest('[data-vw-switch-tab]');
    if (!t) return;
    e.preventDefault();
    var tab = t.getAttribute('data-vw-switch-tab');
    var btn = document.querySelector('[data-vc-tab-btn="' + tab + '"]');
    if (btn) {
      btn.click();
      var panel = document.getElementById('vc-tab-' + tab);
      if (panel) panel.scrollIntoView({ behavior:'smooth', block:'start' });
    }
  }, true);

  var customerId = (HOST.getAttribute('data-customer-id') || '').trim();
  var isLoggedIn = !!customerId;
  var lastResponse = null;
  var lastContext = null;
  var savedThisRender = false;
  var pulseAfterRender = false;

  // ------------- Inline SVG iconen (lucide-style, 24x24, currentColor) -------------
  var ICON_LOCK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
    'class="w-6 h-6 shrink-0" aria-hidden="true" focusable="false">' +
    '<rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>' +
    '<path d="M7 11V7a5 5 0 0 1 10 0v4"/>' +
    '</svg>';

  var ICON_SAVE =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
    'class="w-6 h-6 shrink-0" aria-hidden="true" focusable="false">' +
    '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>' +
    '<polyline points="17 21 17 13 7 13 7 21"/>' +
    '<polyline points="7 3 7 8 15 8"/>' +
    '</svg>';

  var ICON_CHECK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" ' +
    'class="w-5 h-5 shrink-0" aria-hidden="true" focusable="false">' +
    '<polyline points="20 6 9 17 4 12"/>' +
    '</svg>';

  var ICON_SPIN =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
    'class="w-5 h-5 shrink-0 animate-spin" aria-hidden="true" focusable="false">' +
    '<path d="M21 12a9 9 0 1 1-6.219-8.56"/>' +
    '</svg>';

  // ------------- Pulse / animation styles (inline, scoped) -------------
  (function injectStyles(){
    if (document.getElementById('vw-save-styles')) return;
    var st = document.createElement('style');
    st.id = 'vw-save-styles';
    st.textContent =
      '@keyframes vwPulseRing { 0% { box-shadow: 0 0 0 0 rgba(20,184,166,.55);} ' +
      '70% { box-shadow: 0 0 0 14px rgba(20,184,166,0);} ' +
      '100% { box-shadow: 0 0 0 0 rgba(20,184,166,0);} }' +
      '.vw-pulse-cta { animation: vwPulseRing 1.8s ease-out 3; }' +
      '@keyframes vwToastIn { from { opacity:0; transform: translateY(12px);} ' +
      'to { opacity:1; transform: translateY(0);} }' +
      '#vw-toast-host { position: fixed; z-index: 300; bottom: 16px; right: 16px; ' +
      'display:flex; flex-direction:column; gap:8px; pointer-events:none; max-width: 360px;}' +
      '@media (min-width: 768px) { #vw-toast-host { top: 16px; bottom: auto; } }' +
      '.vw-toast { pointer-events:auto; animation: vwToastIn 220ms ease-out;' +
      'background:#0B1E36; color:#fff; padding:12px 14px; border-radius:12px;' +
      'box-shadow:0 8px 24px rgba(0,0,0,.18); font-size:14px; display:flex;' +
      'align-items:flex-start; gap:10px; }' +
      '.vw-toast--ok { background:#0B1E36; }' +
      '.vw-toast--err { background:#7f1d1d; }' +
      '.vw-toast button { background: transparent; color:#fff; text-decoration:underline;' +
      'border:none; padding:0; margin-left:auto; cursor:pointer; font:inherit; }' +
      '@media (prefers-reduced-motion: reduce) {' +
      ' .vw-pulse-cta { animation: none; } .vw-toast { animation: none; } }';
    document.head.appendChild(st);
  })();

  // ------------- Cohort-toestemming (AVG) -------------
  // 16-10-2026: de blokkerende modal (snippets/vw-cohort-consent.liquid) is
  // vervangen door een vinkje bij de bewaarknop. Standaard UIT: vooraf
  // aangevinkte toestemming is geen geldige toestemming (HvJ EU, Planet49).
  // De keuze wordt onthouden in localStorage, zelfde sleutels als voorheen,
  // zodat de instelling op de historie-pagina blijft werken.
  function cohortOnthouden(){
    try { return localStorage.getItem('vw_cohort_consent_value') === 'true'; } catch(_){ return false; }
  }
  function cohortVinkje(){
    return (
      '      <label class="flex items-start gap-2 mt-3 mb-3 text-sm text-slate-700 cursor-pointer select-none">' +
      '        <input type="checkbox" data-vw-cohort-cb class="mt-0.5 w-4 h-4 rounded border-slate-400 text-aqua-donker focus:ring-aqua"' + (cohortOnthouden() ? ' checked' : '') + '>' +
      '        <span>Meting anoniem meenemen in landelijke vijvertrends <span class="text-slate-500">(optioneel, niet herleidbaar tot jou)</span></span>' +
      '      </label>'
    );
  }
  function leesCohortVinkje(){
    var cb = ctx().querySelector('[data-vw-cohort-cb]');
    // Geen vinkje in beeld (de exit-popover): geen toestemming, en de onthouden keuze blijft staan.
    if (!cb) return false;
    var aan = !!cb.checked;
    try { localStorage.setItem('vw_cohort_consent_asked', 'true'); } catch(_){}
    try { localStorage.setItem('vw_cohort_consent_value', aan ? 'true' : 'false'); } catch(_){}
    return aan;
  }

  // ------------- Toast-systeem -------------
  function ensureToastHost(){
    var h = document.getElementById('vw-toast-host');
    if (h) return h;
    h = document.createElement('div');
    h.id = 'vw-toast-host';
    h.setAttribute('aria-live','polite');
    h.setAttribute('aria-atomic','true');
    document.body.appendChild(h);
    return h;
  }
  function toast(opts){
    try {
      var host = ensureToastHost();
      var el = document.createElement('div');
      var kind = (opts && opts.kind) || 'ok';
      el.className = 'vw-toast vw-toast--' + (kind === 'err' ? 'err' : 'ok');
      var icon = kind === 'err' ? '' : ICON_CHECK;
      el.innerHTML =
        (icon ? '<span style="display:inline-flex;margin-top:2px;">' + icon + '</span>' : '') +
        '<span>' + escapeHtml(opts.msg || '') + '</span>' +
        (opts.action ? '<button type="button" data-vw-toast-action>' + escapeHtml(opts.action) + '</button>' : '');
      host.appendChild(el);
      if (opts.action && typeof opts.onAction === 'function'){
        el.querySelector('[data-vw-toast-action]').addEventListener('click', function(){
          try { opts.onAction(); } catch(_){ }
          remove();
        });
      }
      var ms = opts.ms || 4000;
      var t = setTimeout(remove, ms);
      function remove(){ clearTimeout(t); try { el.remove(); } catch(_){ } }
    } catch (e){ /* toast mag nooit crashen */ }
  }

  // Listen op het bestaande analytics-event van vijvercheck-v2.js
  document.addEventListener('vw:advice', onAdvice, false);

  function onAdvice(ev){
    try {
      var detail = (ev && ev.detail) || {};
      lastResponse = detail.response || null;
      lastContext = detail.context || null;
      savedThisRender = false;
      stap = 'bewaren';
      lokaalBewaard = false;
      metingId = null;
      render();
      maybeRestoreAfterLogin();
    } catch (e){
      console.warn('[vw-save] onAdvice error', e);
    }
  }

  function escapeHtml(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ------------- Login-return-flow -------------
  function persistPendingForLogin(){
    try {
      if (!lastContext) return;
      var payload = {
        context: lastContext,
        response: lastResponse,
        ts: Date.now()
      };
      localStorage.setItem(PENDING_KEY, JSON.stringify(payload));
    } catch (e){ /* localStorage geblokkeerd: graceful */ }
  }
  function getPending(){
    try {
      var raw = localStorage.getItem(PENDING_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      // 24u-bewaartijd
      if (!obj || (Date.now() - (obj.ts || 0)) > 24*3600*1000){
        localStorage.removeItem(PENDING_KEY);
        return null;
      }
      return obj;
    } catch(_){ return null; }
  }
  function clearPending(){
    try { localStorage.removeItem(PENDING_KEY); } catch(_){ }
  }
  function isRestoreFlow(){
    try {
      var u = new URL(window.location.href);
      return u.searchParams.get('restore') === '1';
    } catch(_){ return false; }
  }
  function maybeRestoreAfterLogin(){
    if (!isLoggedIn || !isRestoreFlow()) return;
    var pending = getPending();
    if (!pending) return;
    // Context al gerendered via vw:advice; we tonen alleen toast + pulse
    pulseAfterRender = true;
    applyPulse();
    toast({
      kind: 'ok',
      msg: 'Welkom terug. Klik op Bewaar meting om je waarden op te slaan.',
      ms: 6000
    });
  }
  function applyPulse(){
    if (!pulseAfterRender) return;
    var btn = HOST.querySelector('[data-vw-save-btn]');
    if (btn) btn.classList.add('vw-pulse-cta');
  }

  // ------------- Render -------------
  function buildLoginHref(){
    // Shopify Customer Account strip soms query/fragment; bewaar intent in localStorage
    try { localStorage.setItem('vw_post_login_action', JSON.stringify({tab:'historie', restore:1, ts:Date.now()})); } catch(_){}
    var base = window.location.pathname || '/pages/vijvercheck-app';
    // 23-07-2026: return_to (nieuwe klantaccounts) en netjes koppelen;
    // de intent staat toch al in localStorage voor als de parameter
    // door het accountsysteem genegeerd wordt.
    return '/customer_authentication/login?return_to=' + encodeURIComponent(base);
  }


  // Voorproefje van het trend-dashboard. Nadrukkelijk een VOORBEELD, geen data van
  // de bezoeker: mensen weten niet wat ze terugkrijgen, dus laten we het zien.
  // Stijl gelijk aan vijvercheck-history-v3.js (aqua #0EA5B7, groene goed-band,
  // pH-doelgebied 7,0 tot 8,5) zodat het beeld klopt met de echte pagina.
  function voorproefjeSVG(){
    // y = 72 - (pH - 7.6) * 40  -> bereik 7,6 onderaan tot 9,2 bovenaan
    var punten = '26,20 87,28 148,40 210,48 271,52';
    return '' +
      '<figure class="mt-1 mb-3">' +
      '  <svg viewBox="0 0 280 90" role="img" aria-label="Voorbeeldgrafiek van een pH-verloop dat over vijf metingen daalt naar het goede gebied" class="w-full max-w-[320px] h-auto">' +
      '    <rect x="26" y="8"  width="246" height="8"  fill="rgba(249,115,22,0.14)"/>' +
      '    <rect x="26" y="16" width="246" height="20" fill="rgba(250,204,21,0.12)"/>' +
      '    <rect x="26" y="36" width="246" height="36" fill="rgba(34,197,94,0.10)"/>' +
      '    <line x1="26" y1="36" x2="272" y2="36" stroke="rgba(34,197,94,0.55)" stroke-width="1" stroke-dasharray="3 3"/>' +
      '    <polyline points="' + punten + '" fill="none" stroke="#0EA5B7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '    <circle cx="26" cy="20" r="3" fill="#0EA5B7"/>' +
      '    <circle cx="87" cy="28" r="3" fill="#0EA5B7"/>' +
      '    <circle cx="148" cy="40" r="3" fill="#0EA5B7"/>' +
      '    <circle cx="210" cy="48" r="3" fill="#0EA5B7"/>' +
      '    <circle cx="271" cy="52" r="4" fill="#0EA5B7" stroke="#fff" stroke-width="2"/>' +
      '    <text x="2" y="23" font-size="9" fill="#64748B">9,2</text>' +
      '    <text x="2" y="75" font-size="9" fill="#64748B">7,6</text>' +
      '    <text x="30" y="33" font-size="8" fill="#16803C">goed</text>' +
      '    <text x="26" y="86" font-size="9" fill="#64748B">meting 1</text>' +
      '    <text x="232" y="86" font-size="9" fill="#64748B">meting 5</text>' +
      '  </svg>' +
      '  <figcaption class="mt-1 text-xs text-slate-500">Voorbeeld: zo zie je of je pH de goede kant op gaat.</figcaption>' +
      '</figure>';
  }

  // De opslaanvelden staan of in de vaste CTA of in de exit-popover. ctx() wijst
  // naar de container die op dit moment actief is, zodat onSaveClick beide bedient.
  var POPOVER = null;
  function ctx(){ return POPOVER || HOST; }

  function render(){
    if (!HOST) return;
    HOST.innerHTML = '';
    // Toon save-CTA pas als er ECHT advies-cards zijn (niet bij empty-state)
    var adviceContainer = document.getElementById('vw-advies-cards');
    var hasCards = adviceContainer && adviceContainer.querySelectorAll('[data-vw-card], .vw-card').length > 0;
    if (!hasCards) { return; }
    if (!isLoggedIn){
      // 18-07-2026: geen loginmuur meer. 28-07-2026 (run 7, besluit Kees): eerst bewaren,
      // dan pas iets vragen. 18-10-2026 (DPIA A3, B-2026-10-18-3): geen e-mailveld meer. Een
      // gast bewaart op dit apparaat; inloggen zet de metingen in het account (de historie-tab
      // koppelt ze vanzelf, ook de eerdere van dit apparaat).
      if (stap === 'bewaren'){
        HOST.innerHTML =
          '<div class="mt-6 p-4 rounded-xl border border-aqua/30 bg-aqua/5">' +
          '  <div class="flex items-start gap-3">' +
          '    <span class="text-aqua-donker mt-0.5">' + ICON_SAVE + '</span>' +
          '    <div class="flex-1 min-w-0">' +
          '      <h3 class="font-semibold text-navy text-base mb-1">Bewaar deze meting en volg je vijver</h3>' +
          '      <p class="text-sm text-slate-700 mb-3">Bij je volgende meting zie je meteen of je pH stabiel blijft en of je KH de goede kant op gaat.</p>' +
          voorproefjeSVG() +
          cohortVinkje() +
          '      <button type="button" data-vw-bewaar-btn ' +
          '              class="inline-flex items-center justify-center gap-2 min-h-[44px] px-5 py-2.5 rounded-lg bg-aqua-donker text-white font-semibold hover:bg-aqua/90 focus-visible:ring-2 focus-visible:ring-aqua focus-visible:ring-offset-2 w-full sm:w-auto">' +
          '        <span class="inline-flex">' + ICON_SAVE + '</span>' +
          '        <span>Bewaar deze meting</span>' +
          '      </button>' +
          '      <div data-vw-save-status class="mt-2 text-sm" aria-live="polite"></div>' +
          '      <p class="mt-2 text-xs text-slate-500">Dat gaat meteen, je hoeft niets in te vullen. De meting staat dan op dit apparaat; log daarna in om hem in je account te bewaren.</p>' +
          '    </div>' +
          '  </div>' +
          '</div>';
        if (!vwCtaShown.out){ vwCtaShown.out = true; vwTr('vw_save_cta_shown', { logged_in: false, stap: 'bewaren' }); }
        var bewaarBtn = HOST.querySelector('[data-vw-bewaar-btn]');
        if (bewaarBtn){
          bewaarBtn.addEventListener('click', function(ev){
            ev.preventDefault();
            var cohort = false;
            try { cohort = leesCohortVinkje(); } catch(_){ cohort = false; }
            if (!bewaarAlsGast(cohort)){
              var st = HOST.querySelector('[data-vw-save-status]');
              if (st){
                st.innerHTML = '<span class="text-amber-700">Bewaren op dit apparaat lukt niet in deze browser. ' + loginLinkHtml('Log in om je meting te bewaren') + '.</span>';
                bindLoginLinks(st);
              }
              return;
            }
            render();
            var login = HOST.querySelector('[data-vw-login-link]');
            if (login){ try { login.focus({ preventScroll: true }); } catch(_){ try { login.focus(); } catch(__){} } }
          });
        }
        return;
      }

      // Stap 2: er staat nu echt iets bewaard. Een duidelijke weg naar het account, geen formulier.
      var aantalLokaal = lokaleMetingen().length;
      HOST.innerHTML =
        '<div class="mt-6 p-4 rounded-xl border border-aqua/30 bg-aqua/5">' +
        '  <div class="flex items-start gap-3">' +
        '    <span class="text-green-700 mt-0.5">' + ICON_CHECK + '</span>' +
        '    <div class="flex-1 min-w-0">' +
        '      <h3 class="font-semibold text-navy text-base mb-1">Bewaard op dit apparaat</h3>' +
        '      <p class="text-sm text-slate-700 mb-1">Je waarden staan opgeslagen in deze browser' +
        (aantalLokaal > 1 ? ' (' + aantalLokaal + ' metingen)' : '') + '. Bij je volgende meting zie je het verloop.</p>' +
        '      <p class="text-sm text-slate-700 mb-3">Wil je ze ook op je telefoon terugzien en niet kwijtraken als je je browser opschoont? Log in, dan zetten we ze vanzelf in je account.</p>' +
        '      <div class="flex flex-col sm:flex-row gap-3 sm:items-stretch">' +
        '        <a href="' + escapeHtml(buildLoginHref()) + '" data-vw-login-link ' +
        '           class="inline-flex items-center justify-center gap-2 min-h-[44px] px-5 py-2.5 rounded-lg bg-aqua-donker text-white font-semibold hover:bg-aqua/90 focus-visible:ring-2 focus-visible:ring-aqua focus-visible:ring-offset-2 w-full sm:w-auto">' +
        '          <span class="inline-flex">' + ICON_LOCK + '</span>' +
        '          <span>Log in om je metingen te bewaren</span>' +
        '        </a>' +
        // 31-08-2026: laat meteen zien WAT er bewaard is; de historie-tab toont ook de
        // lokale metingen, dus deze knop leidt niet naar een accountmuur.
        '        <button type="button" data-vw-switch-tab="historie" ' +
        '                class="inline-flex items-center justify-center gap-2 min-h-[44px] px-4 py-2 rounded-lg border border-slate-300 bg-white text-navy font-semibold text-sm hover:bg-slate-50 focus-visible:ring-2 focus-visible:ring-aqua focus-visible:ring-offset-2 w-full sm:w-auto">' +
        '          Bekijk je overzicht' +
        '        </button>' +
        '      </div>' +
        '      <p class="mt-2 text-xs text-slate-500">Nog geen account? Bij het inloggen maak je er meteen een aan. Je meting blijft op dit apparaat staan.</p>' +
        '    </div>' +
        '  </div>' +
        '</div>';
      if (!vwCtaShown.koppel){ vwCtaShown.koppel = true; vwTr('vw_save_koppel_getoond', { totaal: aantalLokaal, stap: 'login' }); }
      bindLoginLinks(HOST);
      return;
    }

    HOST.innerHTML =
      '<div class="mt-6 p-4 rounded-xl border border-aqua/30 bg-aqua/5">' +
      '  <div class="flex items-start gap-3">' +
      '    <span class="text-aqua-donker mt-0.5">' + ICON_SAVE + '</span>' +
      '    <div class="flex-1 min-w-0">' +
      '      <h3 class="font-semibold text-navy text-base mb-1">Bewaar deze meting in mijn historie</h3>' +
      '      <p class="text-sm text-slate-700 mb-3">Volgende keer zie je je trends, krijg je een weekly update en heb je een dossier voor de dierenarts.</p>' +
      cohortVinkje() +
      '      <div class="flex flex-col sm:flex-row gap-3 sm:items-stretch">' +
      '        <button type="button" data-vw-save-btn ' +
      '                class="inline-flex items-center justify-center gap-2 min-h-[44px] px-5 py-2.5 rounded-lg bg-aqua-donker text-white font-semibold hover:bg-aqua/90 focus-visible:ring-2 focus-visible:ring-aqua focus-visible:ring-offset-2 w-full sm:w-auto">' +
      '          <span data-vw-save-icon class="inline-flex">' + ICON_SAVE + '</span>' +
      '          <span data-vw-save-label>Bewaar deze meting in mijn historie</span>' +
      '        </button>' +
      '        <button type="button" data-vw-switch-tab="historie" ' +
      '           class="inline-flex items-center justify-center min-h-[44px] px-5 py-2.5 rounded-lg border border-slate-300 bg-white text-navy font-semibold hover:bg-slate-50 focus-visible:ring-2 focus-visible:ring-aqua focus-visible:ring-offset-2 w-full sm:w-auto">' +
      '          Open dashboard' +
      '        </button>' +
      '      </div>' +
      '      <div data-vw-save-status class="mt-2 text-sm" aria-live="polite"></div>' +
      '    </div>' +
      '  </div>' +
      '</div>';

    var btn = HOST.querySelector('[data-vw-save-btn]');
    if (btn) btn.addEventListener('click', onSaveClick);
    if (!vwCtaShown.inn){ vwCtaShown.inn = true; vwTr('vw_save_cta_shown', { logged_in: true }); }

    // Als we net van login terugkomen: pulse de save-knop
    applyPulse();
  }

  function setButtonState(btn, state){
    var iconHost = btn.querySelector('[data-vw-save-icon]');
    var labelHost = btn.querySelector('[data-vw-save-label]');
    btn.classList.remove('bg-aqua','bg-emerald-600','hover:bg-aqua/90','hover:bg-emerald-700');
    if (state === 'loading'){
      btn.disabled = true;
      btn.setAttribute('aria-busy','true');
      btn.classList.add('bg-aqua');
      if (iconHost) iconHost.innerHTML = ICON_SPIN;
      if (labelHost) labelHost.textContent = 'Bezig met opslaan...';
    } else if (state === 'success'){
      btn.disabled = true;
      btn.removeAttribute('aria-busy');
      btn.classList.add('bg-emerald-600','hover:bg-emerald-700');
      if (iconHost) iconHost.innerHTML = ICON_CHECK;
      if (labelHost) labelHost.textContent = 'Opgeslagen';
      btn.classList.remove('vw-pulse-cta');
    } else { // idle
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.add('bg-aqua','hover:bg-aqua/90');
      if (iconHost) iconHost.innerHTML = ICON_SAVE;
      if (labelHost) labelHost.textContent = btn.getAttribute('data-vw-idle-label') || 'Bewaar deze meting in mijn historie';
    }
  }

  // ------------- Gast: bewaren op dit apparaat, inloggen voor het account -------------
  function bewaarAlsGast(cohort){
    var n = bewaarLokaal(cohort);
    if (!n) return 0;
    lokaalBewaard = true;
    stap = 'bewaard';
    vwTr('vw_save_local', { totaal: n });
    // 31-08-2026: de historie-tab leest deze rijen ook zonder account. Meld de save zodat de
    // tab meteen bijwerkt, ook als hij al eerder gemount was.
    try { window.dispatchEvent(new CustomEvent('vw-lokaal-bewaard')); } catch(_){ }
    try { if (navigator.vibrate) navigator.vibrate(30); } catch(_){}
    return n;
  }
  // Na het inloggen terug naar de historie-tab, waar de lokale rijen vanzelf meegaan.
  function zetLoginIntentie(){
    try { localStorage.setItem('vw_post_login_action', JSON.stringify({ tab: 'historie', ts: Date.now() })); } catch(_){}
  }
  function loginLinkHtml(tekst){
    return '<a href="' + escapeHtml(buildLoginHref()) + '" data-vw-login-link class="underline font-semibold hover:text-navy">' + escapeHtml(tekst) + '</a>';
  }
  function bindLoginLinks(root){
    var links = (root || document).querySelectorAll('[data-vw-login-link]');
    for (var i = 0; i < links.length; i++){
      links[i].addEventListener('click', function(){
        vwTr('vw_save_login_click', {});
        persistPendingForLogin();
        zetLoginIntentie();
      });
    }
  }
  function naarHistorie(){
    try {
      var histBtn = document.querySelector('[data-vc-tab-btn="historie"]');
      if (histBtn) {
        histBtn.click();
        var panel = document.getElementById('vc-tab-historie');
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch(_){}
  }
  // Een 422 van de ingang in gewone taal (velden zoals de ingang ze noemt).
  var VELDNAAM = {
    pH: 'pH', KH_dkh: 'KH', GH_dkh: 'GH', NO2_mg_l: 'nitriet (NO2)', NO3_mg_l: 'nitraat (NO3)',
    PO4_mg_l: 'fosfaat (PO4)',
    NH4_total_mg_l: 'ammonium (NH4)', O2_mg_l: 'zuurstof (O2)', depth_cm: 'de diepte',
    volume_l: 'het volume', air_temp_c: 'de luchttemperatuur', pond_temp_c: 'de watertemperatuur'
  };
  function weigerTekst(body){
    var fout = body && body.fout;
    if (fout === 'geen-meetwaarde') return 'Vul minstens een waterwaarde in (bijvoorbeeld pH of KH), dan kunnen we de meting bewaren.';
    if (fout === 'waarde-ongeldig') return 'De waarde voor ' + (VELDNAAM[body.veld] || 'een veld') + ' valt buiten wat we kunnen bewaren. Controleer hem en probeer het opnieuw.';
    return 'Deze meting kunnen we zo niet bewaren. Controleer je waarden en probeer het opnieuw.';
  }

  // 18-10-2026 (DPIA A2 en A3): alleen wat v2 bewaart. Geen e-mailadres, notities of
  // advies-snapshot meer: de ingang bewaart ze niet en weigert een body boven 16 kB.
  // measured_at laten we weg, dan neemt de ingang zijn eigen tijd en kan een voorlopende klok
  // op het apparaat de meting niet laten weigeren. `id` maakt een tweede poging idempotent.
  function buildPayload(cohortConsent){
    var ctx = lastContext || {};
    var data = (lastResponse && lastResponse.data) || {};
    var measurements = (ctx.measurements && typeof ctx.measurements === 'object') ? ctx.measurements : {};
    var pond = (ctx.pond && typeof ctx.pond === 'object') ? ctx.pond : {};
    var location = (ctx.location && typeof ctx.location === 'object') ? ctx.location : {};
    var forecast = (data.forecast && typeof data.forecast === 'object') ? data.forecast : {};

    var airTemp = null;
    var pondTemp = null;
    if (Array.isArray(forecast.daily_temp) && forecast.daily_temp.length) {
      airTemp = forecast.daily_temp[0];
    } else if (Array.isArray(data.daily_temp) && data.daily_temp.length) {
      airTemp = data.daily_temp[0];
    }
    if (Array.isArray(forecast.pond_temp_forecast) && forecast.pond_temp_forecast.length) {
      pondTemp = forecast.pond_temp_forecast[0];
    } else if (Array.isArray(data.pond_temp_forecast) && data.pond_temp_forecast.length) {
      pondTemp = data.pond_temp_forecast[0];
    }

    return {
      id: metingId,
      postcode: location.postcode || null,
      measurements: measurements,
      pond: {
        depth_cm: inBereik(pond.depth_cm, 30, 500),
        volume_l: inBereik(pond.volume_l, 100, 1000000),
        alg_type: (ctx.observations && ctx.observations.alg_type) || null
      },
      air_temp_c: inBereik(airTemp, -40, 60),
      pond_temp_c: inBereik(pondTemp, -5, 45),
      source: 'vijvercheck-app',
      cohort_consent: !!cohortConsent
    };
  }

  async function onSaveClick(ev){
    ev && ev.preventDefault();
    var btn = ctx().querySelector('[data-vw-save-btn]');
    var status = ctx().querySelector('[data-vw-save-status]');
    if (!btn) return;
    if (savedThisRender){
      if (status) status.innerHTML = '<span class="text-slate-600">Deze meting heb je al bewaard.</span>';
      return;
    }

    // Cohort-toestemming: het vinkje bij de knop (standaard uit), geen modal meer.
    var cohort = false;
    try { cohort = leesCohortVinkje(); } catch (e){ cohort = false; }

    // Gast (de exit-popover): bewaren op dit apparaat; inloggen zet hem in het account.
    if (!isLoggedIn){
      if (!bewaarAlsGast(cohort)){
        if (status){
          status.innerHTML = '<span class="text-amber-700">Bewaren op dit apparaat lukt niet in deze browser. ' + loginLinkHtml('Log in om je meting te bewaren') + '.</span>';
          bindLoginLinks(status);
        }
        return;
      }
      savedThisRender = true;
      setButtonState(btn, 'success');
      if (status){
        status.innerHTML = '<span class="text-green-700 font-semibold">Bewaard op dit apparaat.</span> ' + loginLinkHtml('Log in om je metingen te bewaren') + '.';
        bindLoginLinks(status);
      }
      if (POPOVER) setTimeout(function(){ sluitExit('bewaard'); }, 2500);
      render();
      return;
    }

    setButtonState(btn, 'loading');
    vwTr('vw_save_click', {});
    if (status) status.innerHTML = '<span class="text-slate-600">Bezig met bewaren...</span>';
    if (!metingId) metingId = nieuweMetingId();
    var payload = buildPayload(cohort);
    var opnieuw = function(){ onSaveClick({ preventDefault: function(){} }); };

    try {
      var res = await stuurMeting(payload);
      if (res.status === 401){
        // De winkel ziet je als ingelogd, de App Proxy niet (sessie verlopen). Niets kwijtraken:
        // de meting gaat op dit apparaat en na opnieuw inloggen vanzelf naar het account.
        bewaarLokaal(cohort);
        vwTr('vw_save_error', { status: 401 });
        setButtonState(btn, 'idle');
        if (status){
          status.innerHTML = '<span class="text-amber-700">Je sessie is verlopen. Je meting staat veilig op dit apparaat. ' + loginLinkHtml('Log opnieuw in') + ', dan zetten we hem vanzelf in je historie.</span>';
          bindLoginLinks(status);
        }
        return;
      }
      if (res.status === 422){
        vwTr('vw_save_error', { status: 422, fout: String((res.body && res.body.fout) || '').slice(0, 40) });
        setButtonState(btn, 'idle');
        if (status) status.innerHTML = '<span class="text-amber-700">' + escapeHtml(weigerTekst(res.body)) + '</span>';
        return;
      }
      // GUARD (2026-07-27): de bevestiging moet uit de body komen, een 2xx alleen is geen bewijs.
      var bevestiging = res.body;
      if (!res.ok || !bevestiging || bevestiging.ok !== true || !bevestiging.id){
        // Mislukt of niet bevestigd: de meting gaat op dit apparaat, zodat hij niet verloren
        // gaat. De historie-tab zet hem later met hetzelfde id alsnog in het account.
        bewaarLokaal(cohort);
        vwTr(res.ok ? 'vw_save_unconfirmed' : 'vw_save_error', { status: res.status });
        setButtonState(btn, 'idle');
        var waarom = res.status === 429
          ? 'Je hebt net vaak bewaard.'
          : 'Bewaren in je historie lukte nu niet' + (res.ok ? '' : ' (status ' + res.status + ')') + '.';
        if (status) status.innerHTML = '<span class="text-amber-700">' + escapeHtml(waarom) + ' Je meting staat veilig op dit apparaat en gaat vanzelf mee naar je historie zodra het weer lukt.</span>';
        toast({ kind:'err', msg:'Niet gelukt: probeer opnieuw.', action:'Opnieuw', onAction: opnieuw });
        return;
      }
      savedThisRender = true;
      // Stond deze meting door een eerdere mislukte poging al lokaal: die staat nu in het account.
      markeerLokaalGekoppeld(metingId, bevestiging.id);
      // In de exit-popover: even de bevestiging laten zien, dan vanzelf sluiten.
      if (POPOVER) setTimeout(function(){ sluitExit('bewaard'); }, 1800);
      clearPending();
      setButtonState(btn, 'success');
      // Haptic feedback op mobile (Agent 4 mobile-fix)
      try { if (navigator.vibrate) navigator.vibrate(40); } catch(_){}
      try { window.dispatchEvent(new CustomEvent('vw-measurement-saved')); } catch(_){}
      // Auto-switch naar de historie-tab en scroll naar boven na het bewaren.
      naarHistorie();
      // 18-10-2026: de link naar de oude historiepagina (301 naar deze pagina) is vervangen
      // door de tab-wissel; die pagina en haar assets zijn opgeruimd.
      if (status){
        status.innerHTML =
          '<span class="text-green-700 font-semibold">Meting bewaard in je historie.</span> ' +
          '<button type="button" data-vw-switch-tab="historie" class="underline text-aqua-donker">Bekijk je historie</button>';
      }
      toast({ kind:'ok', msg:'Meting bewaard in je historie.', action:'Open', onAction: naarHistorie });
      try {
        if (typeof window.vwTrack === 'function') window.vwTrack('vw_measurement_saved', { cohort: cohort });
        if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'vw_measurement_saved', cohort_consent: cohort });
      } catch(_){ }
    } catch (e){
      console.warn('[vw-save] network error', e);
      bewaarLokaal(cohort);
      vwTr('vw_save_error', { status: 0, kind: 'network' });
      setButtonState(btn, 'idle');
      if (status) status.innerHTML = '<span class="text-amber-700">Netwerkfout. Je meting staat veilig op dit apparaat en gaat vanzelf mee naar je historie zodra het weer lukt.</span>';
      toast({ kind:'err', msg:'Netwerkfout: probeer opnieuw.', action:'Opnieuw', onAction: opnieuw });
    }
  }


  // ---------------------------------------------------------------------------
  // Exit-intent: laatste kans om de meting te bewaren als iemand weg dreigt te gaan.
  // Reden: bezoekers vullen de check in, lezen het advies en vertrekken zonder te
  // bewaren, waardoor ze bij de volgende meting weer bij nul beginnen.
  // Terughoudend: maximaal één keer per sessie, nooit als er al bewaard is, en
  // alleen als er echt advies op het scherm staat.
  // ---------------------------------------------------------------------------
  var EXIT_KEY = 'vw_exit_getoond';

  function exitAlGetoond(){
    try { return sessionStorage.getItem(EXIT_KEY) === '1'; } catch(_){ return false; }
  }
  function markeerExitGetoond(){
    try { sessionStorage.setItem(EXIT_KEY, '1'); } catch(_){}
  }
  function heeftAdvies(){
    var c = document.getElementById('vw-advies-cards');
    return !!(c && c.querySelectorAll('[data-vw-card], .vw-card').length > 0);
  }
  function magExitTonen(){
    return !POPOVER && !savedThisRender && !lokaalBewaard && !exitAlGetoond() && heeftAdvies();
  }

  function sluitExit(reden){
    if (!POPOVER) return;
    var el = POPOVER;
    POPOVER = null;
    document.removeEventListener('keydown', exitToetsHandler);
    try { document.body.style.overflow = ''; } catch(_){}
    if (el && el.parentNode) el.parentNode.removeChild(el);
    vwTr('vw_exit_popover_dicht', { reden: reden || 'onbekend' });
  }

  function exitToetsHandler(e){
    if (e.key === 'Escape') sluitExit('escape');
  }

  function toonExitPopover(trigger){
    if (!magExitTonen()) return;
    markeerExitGetoond();

    var wrap = document.createElement('div');
    wrap.className = 'fixed inset-0 z-[9999] flex items-end sm:items-center justify-center p-4 bg-navy/60';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'vw-exit-titel');

    // 18-10-2026 (DPIA A3): geen e-mailveld meer. Een gast bewaart op dit apparaat en
    // krijgt daarna de weg naar het account; ingelogd gaat de meting direct in het account.
    var knopTekst = isLoggedIn ? 'Bewaar mijn meting' : 'Bewaar op dit apparaat';

    wrap.innerHTML =
      '<div class="bg-white rounded-2xl shadow-xl border border-slate-200 w-full max-w-md p-5 relative">' +
      '  <button type="button" data-vw-exit-sluit aria-label="Sluiten" ' +
      '          class="absolute top-3 right-3 w-9 h-9 inline-flex items-center justify-center rounded-full text-slate-500 hover:bg-slate-100 focus-visible:ring-2 focus-visible:ring-aqua">&times;</button>' +
      '  <h3 id="vw-exit-titel" class="font-semibold text-navy text-lg mb-1 pr-8">Neem je meting mee</h3>' +
      '  <p class="text-sm text-slate-700 mb-2">Je waarden zijn nu bekend. Bewaar ze, dan zie je bij je volgende meting of je vijver de goede kant op gaat in plaats van dat je weer bij nul begint.</p>' +
      voorproefjeSVG() +
      '  <button type="button" data-vw-save-btn data-vw-idle-label="' + knopTekst + '" ' +
      '          class="inline-flex items-center justify-center gap-2 min-h-[44px] px-5 py-2.5 rounded-lg bg-aqua-donker text-white font-semibold hover:bg-aqua/90 focus-visible:ring-2 focus-visible:ring-aqua focus-visible:ring-offset-2 w-full">' +
      '    <span data-vw-save-icon class="inline-flex">' + ICON_SAVE + '</span>' +
      '    <span data-vw-save-label>' + knopTekst + '</span>' +
      '  </button>' +
      '  <div data-vw-save-status class="mt-2 text-sm" aria-live="polite"></div>' +
      '  <button type="button" data-vw-exit-sluit class="mt-2 w-full text-sm text-slate-500 underline hover:text-navy">Nee, nu even niet</button>' +
      '</div>';

    document.body.appendChild(wrap);
    POPOVER = wrap;
    try { document.body.style.overflow = 'hidden'; } catch(_){}

    wrap.addEventListener('click', function(e){ if (e.target === wrap) sluitExit('buiten-klik'); });
    var sluitKnoppen = wrap.querySelectorAll('[data-vw-exit-sluit]');
    for (var i = 0; i < sluitKnoppen.length; i++){
      sluitKnoppen[i].addEventListener('click', function(){ sluitExit('knop'); });
    }
    var saveKnop = wrap.querySelector('[data-vw-save-btn]');
    if (saveKnop) saveKnop.addEventListener('click', onSaveClick);
    if (saveKnop){
      try { saveKnop.focus(); } catch(_){}
    }
    document.addEventListener('keydown', exitToetsHandler);

    vwTr('vw_exit_popover_getoond', { trigger: trigger, logged_in: isLoggedIn });
  }

  // Desktop: muis verlaat het venster aan de bovenkant (richting tabs of adresbalk).
  document.addEventListener('mouseout', function(e){
    if (e.clientY > 0) return;
    if (e.relatedTarget || e.toElement) return;
    toonExitPopover('desktop-muis');
  });

  // Mobiel: geen muis, dus kijken we naar een snelle veeg omhoog (richting adresbalk
  // of terugknop). Drempel bewust hoog zodat gewoon terugscrollen hem niet triggert.
  var laatsteY = window.pageYOffset || 0;
  var laatsteT = Date.now();
  window.addEventListener('scroll', function(){
    var y = window.pageYOffset || 0;
    var nu = Date.now();
    var dy = laatsteY - y;
    var dt = nu - laatsteT;
    if (dt > 0 && dt < 400 && dy > 120 && y < 300){
      toonExitPopover('mobiel-veeg');
    }
    laatsteY = y;
    laatsteT = nu;
  }, { passive: true });

  // Initial render
  render();
  // En check direct of restore-flow al actief is (advies kan al binnen zijn)
  maybeRestoreAfterLogin();
})();



